import { render, staticRenderFns } from "./WeekdaySelector.vue?vue&type=template&id=02ae31c0&scoped=true&"
import script from "./WeekdaySelector.vue?vue&type=script&lang=ts&"
export * from "./WeekdaySelector.vue?vue&type=script&lang=ts&"
import style0 from "./WeekdaySelector.vue?vue&type=style&index=0&id=02ae31c0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ae31c0",
  null
  
)

export default component.exports